<template>
  <v-dialog v-model="isOpen" width="300" class>
    <v-card id="itt-modal-responsivity">
      <v-card-title>
        <span class="headline">{{$t('titles.display')}} </span>
      </v-card-title>
      <v-card-text>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex xs12>
              <v-radio-group v-model="valueRadio" column>
                <v-radio color="primary" :label="'2 ' + $t('texts.columns')" value="6" class="class-radio"></v-radio>
                <v-radio color="primary" :label="'3 ' + $t('texts.columns')" value="4" class="class-radio"></v-radio>
                <v-radio color="primary" :label="'4 ' + $t('texts.columns')" value="3" class="class-radio"></v-radio>
                <v-radio color="primary" :label="'6 ' + $t('texts.columns')" value="2" class="class-radio"></v-radio>
                <v-radio color="primary" :label="'12 ' + $t('texts.columns')" value="1" class="class-radio"></v-radio>
              </v-radio-group>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions class="center">
        <v-btn color="primary" flat @click="toggle">{{$t('buttons.close')}}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  data() {
    return {
      valueRadio: '4',
    }
  },
  computed: {
    isOpen: {
      get() {
        this.valueRadio = this.$store.getters['image/getFilterResponsivity'];
        return this.$store.getters["dialogModal/isOpenResponsivity"];
      },
      set() {
        this.toggle();
        return this.$store.getters["dialogModal/isOpenResponsivity"];
      }
    }
  },
  methods: {
    toggle() {
      this.$store.dispatch("dialogModal/toggleResponsivity");
    },
  },
  watch: {
    valueRadio: function(value) {
      this.$store.dispatch("image/filterResponsivity", value);
    }
  }
};
</script>
<style lang="sass">
#itt-modal-responsivity
  button:focus
    outline: 0
  .headline, .v-input__control
    margin: auto
  


.class-radio > label 
  margin: 0px

.v-dialog .container.grid-list-md 
  padding-top: 0
  padding-bottom: 0

</style>
